import { SearchIcon } from '@/shared/ui/icons'
import { cn } from '@/shared/lib/cn'
import { getModKAriaKeyshortcuts, getModKShortcutLabel } from '@/shared/lib/keyboardShortcutLabel'
import { Tooltip } from '@/shared/ui/Tooltip'

type GoToSearchTriggerProps =
  | {
      variant: 'sidebar'
      collapsed: boolean
      onOpen: () => void
    }
  | {
      variant: 'headerIcon'
      onOpen: () => void
      className?: string
    }

export const GoToSearchTrigger = (props: GoToSearchTriggerProps) => {
  const shortcut = getModKShortcutLabel()
  const ariaShortcuts = getModKAriaKeyshortcuts()

  if (props.variant === 'headerIcon') {
    return (
      <button
        type="button"
        onClick={props.onOpen}
        aria-label="Pesquisar páginas"
        aria-keyshortcuts={ariaShortcuts}
        className={cn(
          'inline-flex h-11 w-11 min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-[var(--color-chrome-foreground)] transition-colors hover:bg-[var(--color-chrome-hover)] md:hidden',
          props.className,
        )}
      >
        <SearchIcon size={22} aria-hidden />
      </button>
    )
  }

  const { collapsed, onOpen } = props
  const label = collapsed ? `Pesquisar… (${shortcut})` : 'Pesquisar…'

  const control = (
    <button
      type="button"
      onClick={onOpen}
      aria-label={label}
      aria-keyshortcuts={ariaShortcuts}
      className={cn(
        'flex w-full min-h-11 items-center rounded-2xl border border-[var(--color-border)] bg-[var(--color-page)] text-sm text-[var(--color-text-secondary)] transition-colors hover:bg-[var(--color-mint-soft)]/40',
        collapsed ? 'justify-center px-2 py-2.5' : 'gap-2.5 px-3 py-2 text-left',
      )}
    >
      <SearchIcon size={18} className="shrink-0" aria-hidden />
      {!collapsed ? (
        <>
          <span className="min-w-0 flex-1 truncate font-medium">Pesquisar…</span>
          <kbd
            className="shrink-0 rounded-md border border-[var(--color-border)] bg-[var(--color-bg-surface)] px-1.5 py-0.5 font-mono text-[10px] font-bold text-[var(--color-text-muted)]"
          >
            {shortcut}
          </kbd>
        </>
      ) : null}
    </button>
  )

  if (collapsed) {
    return (
      <Tooltip label={label}>
        {control}
      </Tooltip>
    )
  }

  return control
}
